export class Resource {
    id: string | any
}